<div class="grower-add-sec editPage">
  <div class="search-box-inner">
    <form name="" action="">
      Order Details
      <i class="fas fa-angle-down" aria-hidden="true"></i>
      <span class="float-r">
        <i class="fas fa-ellipsis-v"></i>
      </span>
    </form>
  </div>
  <div class="grower-order-info">
    <div class="row grower-info-sec">
      <div class="col-md-4 col-sm-12 border-dashed">
        <div class="grower-hover">
          <div class="row">
            <div class="col-4">Account: </div>
            <div class="col-8 text-md-right text-left info-value">
              <span *ngIf="SelAccountObj">
                {{SelAccountObj?.accountNumber}} - {{SelAccountObj?.accountName}}
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-4">Address:</div>
            <div class="col-8 text-md-right text-left info-value">{{SelAccountObj?.address1}}, {{SelAccountObj?.city}} - {{SelAccountObj?.state}} {{SelAccountObj?.zipCode}}</div>
          </div>
        </div>
      </div>
      <div class="col-md-4 border-dashed">
        <div class="grower-hover" [ngClass]="{'grower-info-hover': showGrowerInfo === true}">
          <div class="row">
            <div class="col-4">Grower: </div>
            <div class="col-8 text-md-right text-left info-value bold">
              <span (mouseover)="showGrowerInfo=true" (mouseout)="showGrowerInfo=false" (click)="showGrowerInfo=true" class="handCursor" appClickOutside (clickOutside)="showGrowerInfo=false">
                {{SelGrowerObj?.growerName}}
              </span>
            </div>
          </div>
          <div class="row" *ngIf="showGrowerInfo">
            <div class="col-md-4 col-lg-2">GMK: </div>
            <div class="col-md-8 col-lg-10 text-right info-value">{{SelGrowerObj?.gmk}}</div>
          </div>
          <div class="row" *ngIf="showGrowerInfo">
            <div class="col-md-4 col-lg-2">GLN: </div>
            <div class="col-md-8 col-lg-10 text-right info-value">{{SelGrowerObj?.gln}}</div>
          </div>
          <div class="row" *ngIf="showGrowerInfo">
            <div class="col-md-4 col-lg-2">Address: </div>
            <div class="col-md-8 col-lg-10 text-right info-value">{{SelGrowerObj?.growerAddress}}, {{SelGrowerObj?.city}} - {{SelGrowerObj?.state}} {{SelGrowerObj?.zipCode}}</div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-4">
            Created:
          </div>
          <div class="col-8 info-value text-left">
            {{SelGrowerObj?.lastUpdatedAt | date:'MMMM dd, yyyy'}}
          </div>
        </div>
      </div>
    </div>
    <div class="growerIdOuter">
      <div class="row">
        <div class="col-md-4">
          <div class="row">
            <div class="col-4">
              Grower Order# :
            </div>
            <div class="col-8 grower-order-no text-left">
              <span>{{SelGrowerObj?.orderID}}</span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="row" *ngIf="isSubscriptionAccess">
            <div class="col-4">
              <span class="customer-po display-ib padding-t20 padding-l2">
                Non-Subscriber Email:
              </span>
            </div>
            <div class="col-8  padding-r0 growerInputField margin-t-5">
              <mat-form-field class="example-full-width">
                <input matInput type="text" name="accountEmail" [readonly]="disableOnLock" maxlength="250"
                       [(ngModel)]="accountEmail"
                       [pattern]="emailPattern"
                       placeholder="(Separate multiple email addresses by a semi-colon)"
                       [readonly]="accessTypeMode"
                       (blur)="validateEmail()"
                       [errorStateMatcher]="matcher">
                <mat-error *ngIf="isInvalidEmail">
                  This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="col-md-2" *ngIf ="!isMobile">
          <div class="row justify-content-center align-items-center w-100 h-100 view-pdf-print" (click) ="generatePdf()">
            <div class="col-2 pdfText mt-0">
              <span class="round-icon mobile-round">
                <app-growerGeneratePdf #pdfGenerator [growerId]="selGrowerOrderId" class="far fa-file-pdf"></app-growerGeneratePdf>
              </span>
            </div>
            <div class="col-7 pdfText ml-3 mt-2">
              <p class="mb-1">View PDF to Print</p>
            </div>
            </div>
          </div>
      </div>
    </div>
    <app-addeditorderdetail (GetErrorMsgs)="getCommonErrors($event)" [GrowerOrderObj]="SelGrowerObj" [growerId]="getGrowerOrderId" [GrowerOrderItemList]="updatedProductList" [AccountId]="accountNo"></app-addeditorderdetail>
  </div>
  <div class="common-error-block dealer-grower-order-detail" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index]?.errors.length > 0">
    <div class="row">
      <div class="col-3 col-md-1 padding-r0 errCountOuter">
        <!--<span class="close-icon">
          <i class="icon-ico-Error"></i>
        </span>-->
        <span>
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-9 col-md-7 padding-l0 ">
        <ol class="error-list">
          <li *ngFor="let err of errorMsgs[index].errors">
            {{err.error}}
          </li>
        </ol>
        <!--<div class="errorMsg">
          <p>Quantity is not available!</p>
          <span>Please adjust your Quantity</span>
        </div>-->
      </div>
      <div class="col-12 col-md-4 button-sec text-right">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()">Next Error</button>
      </div>
    </div>
  </div>
</div>
